import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { ConnectedRouter } from 'connected-react-router';
import { ToastContainer } from 'react-toastify';

import Routes from 'routes';
import routesConfig from 'routes/config';
import { store, persistor } from 'store';
import history from 'store/history';

import SdkLoader from 'views/components/sdk-loader';
import ScreenLoading from 'views/ui/screen-loading';
import ChatWithScript from 'views/components/chat-with';

const App = () => (
  <Provider store={store}>
    <PersistGate loading={<ScreenLoading />} persistor={persistor}>
      <SdkLoader>
        <ToastContainer
          className="ui-toast__container"
          toastClassName="ui-toast__wrapper"
          bodyClassName="ui-toast__body"
        />
        <ConnectedRouter history={history}>
          <Routes store={store} routes={routesConfig} />
          <ChatWithScript />
        </ConnectedRouter>
      </SdkLoader>
    </PersistGate>
  </Provider>
);

export default App;
